export default {
    name: 'sticky-elem',
    inserted(el, binding) {
        const { offset = 8, direction = 'top', background = '', shadow } =
            binding.value || {}

        const handleScroll = () => {
            let addOffset = 0
            let isSticky
            const rect = el.getBoundingClientRect()

            if (direction === 'top') {
                const headerHeight = parseInt(
                    getComputedStyle(document.documentElement).getPropertyValue(
                        '--header-height'
                    ),
                    10
                )
                addOffset = headerHeight + offset
                isSticky = rect[direction] <= addOffset
                el.style[direction] = isSticky ? addOffset + 'px' : ''

                const offs = offset + 1
                el.style.setProperty('--offset', `-${offs}px`)

                if (isSticky) {
                    el.classList.add('sticky-elem')
                } else {
                    el.classList.remove('sticky-elem')
                }
            } else {
                if (!el.classList.contains('sticky-elem')) {
                    el.classList.add('sticky-elem')
                }

                addOffset =
                    offset +
                    (document.querySelector('.selected')?.offsetHeight || 0)

                isSticky = rect.bottom >= window.innerHeight - addOffset
                el.style[direction] = isSticky ? addOffset + 'px' : ''

                if (!isSticky) {
                    el.classList.remove('sticky-elem')
                }

                const offs = offset + 1
                el.style.setProperty('--offset', `${offs}px`)
            }

            if (background) {
                el.style.setProperty('--offset-background', background)
            }

            if (isSticky && shadow) {
                el.style.boxShadow = typeof shadow === 'string' ? shadow : '0 2px 8px rgba(0,0,0,0.15)'
            } else {
                el.style.boxShadow = ''
            }
        }

        window.addEventListener('scroll', handleScroll)

        // In case the element is already out of view on initial render
        handleScroll()

        el._stickyScrollHandler = handleScroll
    },

    unbind(el) {
        window.removeEventListener('scroll', el._stickyScrollHandler)
    }
}
